import type { Stage } from '@/variants'
export type { Stage }

export type StatusFilter = Stage | 'zurueckgezogen'

export const RUECKZUG_GRUENDE = ['kostentraeger', 'arbeitsaufnahme', 'krankheit', 'umzug', 'fehlende_mitwirkung', 'sonstiges'] as const
export type RueckzugGrundArt = (typeof RUECKZUG_GRUENDE)[number]

export const rueckzugGrundText = (label: string, text: string | null) => (text ? `${label} (${text})` : label)

export type DashboardCoaching = {
  id: string
  name: string | null
  stage: Stage
  documents: string[]
  sheets: string[]
  sitzungDaten: Record<string, string>
  docCount: number
  ueGesamt: number | null
  ueStattgefunden: number
  coach: string
  coachId: string | null
  secondCoachId?: string | null
  secondCoach?: string
  kostentraeger: string
  kostentraegerId: string | null
  gueltigkeitBeginn: string | null
  gueltigkeitEnde: string | null
  beginn: string | null
  aufgabe: string | null
  statusSeit?: string | null
  zurueckgezogen?: { am: string; von: string | null; grundArt: RueckzugGrundArt | null; grund: string | null } | null
  eingeschraenkt?: boolean
}

export type ZurueckgezogenCoaching = DashboardCoaching & {
  zurueckgezogen: NonNullable<DashboardCoaching['zurueckgezogen']>
}

export const hatRueckzug = (c: DashboardCoaching): c is ZurueckgezogenCoaching => !!c.zurueckgezogen

export const anzeigeName = (c: Pick<DashboardCoaching, 'name'>): string => c.name ?? '—'
